import React, { Component } from 'react';
import PT from 'prop-types';

import { Validator } from './validationutils';
import { loadQuestionnaireValues, submitResults, reloadInfoFromFilledForm, TicketInfoShape } from './questionnairemanagementhelper';
import { getValueByOutputRegex } from './functionutils';
import { ReactForm } from 'react-form-js';

const up = require('react-addons-update');
const tsRest = require('ts-rest-client');
const { includes, isEmpty, pick, mergeWith, sortBy, filter, some, orderBy, toLower, forEach, isString, isArray, map, clone, find, concat, findIndex, reduce, flatMap, keys } = require('lodash');

// VIEWS *************************************

/*
Ce controle:
- Édite un kit de formulaires pour 1 order (ou 1 item de panier)
  - Autant les formulaires per-order que per-ticket
- Connactable sur session ou sur BD selon isInAdmin
- Load et save les values par lui même

Autres infos:
- Recoit une list de definitions de formulaire order-level et ticket-level.
- Recoit un résumé d'un item de panier, eventid, eventdateid, packageid, liste de tickets
- Si isInAdmin = false, tous les call Load/Save se font dans la session de l'utilisateur
  - GET and POST @ http://apidevlocal.reservatech.net/sessions/current/salequestionnaires/values?...
- Si isInAdmin = true, tous les call se font sur les données de la BD par formId + orderId + ticektId
  - GET and POST @ http://apidevlocal.reservatech.net/salequestionnaires/values?...
- Sur les GET
  - Load le formdef à partir de l'event
  - Trouve les champs autoFill et rempli à partir du profil si disponible
  - Ce pour tous les formulaire per-order et per-ticket

 */
export class SaleQuestionnaireAutoForm extends Component {
    constructor(props) {
        super(props);

        this.state = {
            showValidationErrors: true, // Don't show them until the first save at least
            filledFormValues: [],
            autoFillInfos: [],
            showErrorMessage: false
        };

        this.handleFormChange = this.handleFormChange.bind(this);
        this.handleOnSubmitResults = this.handleOnSubmitResults.bind(this);
        this.handleCancel = this.handleCancel.bind(this);
    }

    componentDidMount() {
        this.setState({ processing: true });

        this.loadSaleQuestionnaireValuesRequest = loadQuestionnaireValues(this.props.saleQuestionnaireKit, this.props.isInAdmin)
            .then(function(data) {
                this.loadSaleQuestionnaireValues_Success(data);
            }.bind(this)
            );

        if (this.props.onContentChange !== undefined) {
            this.props.onContentChange();
        }
    }

    componentDidUpdate() {
        if (this.props.onContentChange !== undefined) {
            this.props.onContentChange();
        }
    }

    componentWillUnmount() { 
        // if(this.loadSaleQuestionnaireValuesRequest != null) console.log(this.loadSaleQuestionnaireValuesRequest);
        // if(this.itemRequest != null) this.itemRequest.abort();
    }
    
    loadSaleQuestionnaireValues_Success(data) {
        const filledFormValues = map(data, function(formValues) {
            
            const formVal = clone(formValues);
            formVal.Values = (formVal.Values !== "" && formVal.Values !== null) ? JSON.parse(formVal.Values) : {};

            const curTicketInfo = find(this.props.saleQuestionnaireKit.TicketInfos, { id: formValues.TicketID });
            // On ajoute le pricename par default dans les values si c'est un questionnaire par Event
            if(this.props.saleQuestionnaireKit.OwnerPOSID === 0)
                formVal.Values.priceName = (curTicketInfo ? curTicketInfo.priceName : "");

            formVal.InfoSupp = this.getInfoSupp(curTicketInfo);
            
            return formVal;
        }.bind(this));
        this.setState({ filledFormValues: filledFormValues, processing: false });
    }
    
    getFilledFormIndex(filledFormsArray, formID, packageID, eventID, eventDateID, orderID, cartID, ownerPOSID, ticketID) {
        // Find if the filled form already exist
        return findIndex(filledFormsArray, {
            FormID: formID,
            PackageID: packageID,
            EventID: eventID,
            EventDateID: eventDateID,
            OrderID: orderID,
            CartID: toLower(cartID),
            OwnerPOSID: ownerPOSID,
            TicketID: ticketID
        });
    }

    didUpdateField(filledForm, filledFormValues) {
        filledForm.Values = filledFormValues;
        this.handleFormChange(filledForm);
    }

    handleFormChange(newFilledForm){
        // TODO: Replace this with react update helper instead of concat.
        
        // Copie the array
        //eslint-disable-next-line sonarjs/no-dead-store
        let newArray = concat(this.state.filledFormValues);

        // Find if the filled form already exist
        const formIndex = this.getFilledFormIndex(this.state.filledFormValues, newFilledForm.FormID, newFilledForm.PackageID, newFilledForm.EventID, newFilledForm.EventDateID, newFilledForm.OrderID, toLower(newFilledForm.CartID), newFilledForm.OwnerPOSID, newFilledForm.TicketID);
        
        if (formIndex >= 0) {
            newArray = up(this.state.filledFormValues, { [formIndex]: {$set: newFilledForm} });
        } else {
            newArray = up(this.state.filledFormValues, {$push: [newFilledForm]});
        }
        
        this.setState({ filledFormValues: newArray });
    }

    async handleOnSubmitResults (){
        if(!this.checkHaveFormsErrors()) {
            
            this.setState({submitInProgress:true});

            try {
                await submitResults(this.state.filledFormValues, this.props.isInAdmin);

                this.setState({ submitInProgress: false });

                this.props.afterConfirm();
            } catch(err) {
                tsRest.handleError(err);
            }
        }
        else {
            if (this.props.onContentChange !== undefined) {
                this.props.onContentChange();
            }
            this.setState( { showErrorMessage: true });
        }
    }

    handleCancel() {
        if(this.props.onCancel != null) this.props.onCancel();
    }
    
    checkHaveFormsErrors(){
        const cartFormErrors = 
            map(this.props.saleQuestionnaireKit.POSForms.cartForms, (formDef) => {
                const filledForm = this.getFilledForm(formDef, 0);
                return this.getValidationErrors(formDef, filledForm);
            });

        const filledFormErrors = 
            map(this.props.saleQuestionnaireKit.EventForms.orderForms, (formDef) => {
                const filledForm = this.getFilledForm(formDef, 0);
                return this.getValidationErrors(formDef, filledForm);
            });

        const ticketFormsErrors =
            flatMap(this.props.saleQuestionnaireKit.TicketInfos, (ticket) => {
                return map(this.props.saleQuestionnaireKit.EventForms.ticketForms, (formDef) => {
                    const filledForm = this.getFilledForm(formDef, ticket.id);
                    return this.getValidationErrors(formDef, filledForm);
                });
            });

        const nbrErrrors = reduce(concat(cartFormErrors, filledFormErrors, ticketFormsErrors), (acc, val) => { return acc + keys(val).length; }, 0);

        return nbrErrrors > 0;
    }
    
    getInfoSupp(curTicketInfo) {
        const infoSuppValues = [];
        if(this.props.isInAdmin && curTicketInfo && curTicketInfo.code) {
            infoSuppValues.push({ name:"ticketCode", label:"Code du billet", value: (curTicketInfo ? curTicketInfo.code : "") });
        }
        
        return infoSuppValues;
    }
    
    createNewFilledForm(formID, ticketID) {

        const curTicketInfo = find(this.props.saleQuestionnaireKit.TicketInfos, { id: ticketID });


        
        return {
            PackageID:this.props.saleQuestionnaireKit.PackageID,
            EventID: this.props.saleQuestionnaireKit.EventID,
            EventDateID: this.props.saleQuestionnaireKit.EventDateID,
            OrderID: this.props.saleQuestionnaireKit.OrderID,
            CartID: toLower(this.props.saleQuestionnaireKit.CartID),
            OwnerPOSID: this.props.saleQuestionnaireKit.OwnerPOSID,
            TicketID: ticketID,
            FormID: formID,
            Values: { priceName: (curTicketInfo ? curTicketInfo.priceName : "") },
            InfoSupp: this.getInfoSupp(curTicketInfo)
        };
    }

    getFilledFormUniqID(filledForm) {
        if(filledForm.ticketID !== null && filledForm.ticketID !== 0)
            return `${filledForm.FormID}_${filledForm.PackageID}_${filledForm.EventID}_${filledForm.EventDateID}_${filledForm.OrderID}_${filledForm.OwnerPOSID}`;
        else
            return `${filledForm.FormID}_${filledForm.PackageID}_${filledForm.EventID}_${filledForm.EventDateID}_${filledForm.OrderID}_${filledForm.TicketID}`;
    }

    getValidationErrors(formDef, filledForm){
        const errorsByField = {};
        const subFieldsToCheck = [];

        // Boucle de preparation des subfields pour savoir s'ils sont requis ou pas
        forEach(formDef.fields, (field) => {
            let type = field.type;

            if(type === Validator.F_TAGS) {
                forEach(field.possibleValues, (value) => {
                    if(value.subField && value.subField !== "" && includes(filledForm.Values[field.name], value.value)) 
                        subFieldsToCheck.push(value.subField);
                });
            }
        });

        forEach(formDef.fields, (field) => {
            let type = field.type;
            if(type === undefined || type === Validator.F_ONEOF)
                type = Validator.guessValueTypeOfOneOf(field);

            let checkField = !field.isSubField; // À la base on vérifie toutes les fields requis
            if(field.isSubField)
                checkField = includes(subFieldsToCheck, field.name);
                
            if(checkField) {
                const errors = Validator.validate(type, filledForm.Values[field.name], field.isRequired, field.mustBeTrue);
                if(errors.length > 0)
                    errorsByField[field.name] = errors;
            }
        });

        return errorsByField;
    }

    getFilledForm(formDef, ticketID) {
        const filledFormI = this.getFilledFormIndex(this.state.filledFormValues, formDef.id, this.props.saleQuestionnaireKit.PackageID, this.props.saleQuestionnaireKit.EventID, this.props.saleQuestionnaireKit.EventDateID, this.props.saleQuestionnaireKit.OrderID, toLower(this.props.saleQuestionnaireKit.CartID), this.props.saleQuestionnaireKit.OwnerPOSID, ticketID);
        let filledForm = this.state.filledFormValues[filledFormI];
        
        if(filledForm === undefined)
            filledForm = this.createNewFilledForm(formDef.id, ticketID);

        return filledForm; 
    }

    sortFilledForms(formDef, forms) {
        let sortResults = [];
        
        if(formDef.orderBy !== undefined) {
            const orderByFieldNames = [];
            const fieldsOrders = []; 
            forEach(formDef.orderBy, (value, fieldName) => {

                if(isString(value)) {
                    orderByFieldNames.push("Values." + fieldName);
                    // si égal rien ou "asc"
                    if(value === null || value === "asc")
                        fieldsOrders.push("asc");
                    else if(toLower(value) === "desc") 
                        fieldsOrders.push("desc");
                    
                } else if(isArray(value)) {
                    // si égal une liste de values
                    const filterResults = [];
                    forEach(value, (filter) => {
                        const field = find(formDef.fields, { name: fieldName });

                        
                        forEach(forms, (form) => {
                            let retVal = form.Values[fieldName];
                            if(field.outputRegex !== null)
                                retVal = getValueByOutputRegex(retVal, field.outputRegex);
                            
                            if(toLower(retVal) === toLower(filter))
                                return filterResults.push(form);
                        });
                    });

                    if(filterResults.length > 0)
                        sortResults = concat(sortResults, filterResults);
                    
                }
            });

            const notSortResults = filter(forms, (form) => {
                if(!some(sortResults, form))
                    return form;
            });

            // si pas toute tri et aucun tri désigné on tri par le premiere field de la formDef
            if(orderByFieldNames.length > 0 && fieldsOrders.length > 0) {
                return concat(sortResults, orderBy(notSortResults, orderByFieldNames, fieldsOrders));
            } else
            return concat(sortResults, orderBy(notSortResults, ["Values." + formDef.fields[0].name],["desc"])); 
        }
        else {
            // si aucun orderby
            sortResults = clone(forms);
            sortResults = sortBy(sortResults, [formDef.fields[0].name]); // hardcoder le premier fields
        }

        return sortResults;
    }

    getFilledFormWithNoneEditableFields(filledForm,formdef) {
        const noneEditablefieldNames = map(filter(formdef.fields, { editable: false }), "name");

        return pick(filledForm.Values, noneEditablefieldNames);  
    }

    handleClearInfo(filledFormToClear,formdef) {
        filledFormToClear = up(filledFormToClear, { Values: { $set: this.getFilledFormWithNoneEditableFields(filledFormToClear, formdef) } });
        this.handleFormChange(filledFormToClear);
    }

    handleReloadInfo(filledForm) {
        if (filledForm !== undefined) {
            this.loadSaleQuestionnaireValuesRequest = reloadInfoFromFilledForm(filledForm, this.props.isInAdmin) 
                                                        .done(function(data) { this.handleReloadInfo_success(data, filledForm); }.bind(this));
        }
    }

    handleReloadInfo_success(defaultInfos, filledForm) {
        let filledValues = {};
        if(defaultInfos.Values !== null) 
            filledValues = mergeWith(JSON.parse(defaultInfos.Values), filledForm.Values, this.mergeFilledFormWithDefaultInfo);
        
        defaultInfos.Values = filledValues;
        this.handleFormChange(defaultInfos);
    }

    mergeFilledFormWithDefaultInfo(defaultValue, filledFormValue) {
        return  isEmpty(filledFormValue) ? defaultValue : filledFormValue;
    }

    createButtons(filledForm, formDef) {
        return (
            <li key={"buttons_" + this.getFilledFormUniqID(filledForm)}>
                <div className="btn-toolbar pull-right">
                    <button type="button" className="btn btn-info" onClick={() => this.handleClearInfo(filledForm,formDef)}>Vider les informations</button>
                    <button type="button" className="btn btn-info" onClick={() => this.handleReloadInfo(filledForm)}>Remplir les informations</button>
                </div>
            </li>
        );
    }

    createCartFormCtls() {
        const ReactFormChildrenView = this.props.viewProvider.getFormChildrenView();
        let cartFormCtls = null;
        
        if(this.props.saleQuestionnaireKit.POSForms 
            && this.props.saleQuestionnaireKit.POSForms.cartForms 
            && this.props.saleQuestionnaireKit.POSForms.cartForms.length > 0) {

            cartFormCtls = map(this.props.saleQuestionnaireKit.POSForms.cartForms, (formDef) => {
                const filledForm = this.getFilledForm(formDef, 0);
                let filledAutoBtns = null;

                if (formDef.hasAutoFillInfo) {
                    filledAutoBtns = this.createButtons(filledForm, formDef);
                }

                const formContent = (
                    <ReactForm
                        key={"cartform_" + this.getFilledFormUniqID(filledForm)}
                        form={formDef} 
                        filledForm={filledForm.Values} 
                        validationErrors={this.getValidationErrors(formDef, filledForm)}
                        infoSupp={filledForm.InfoSupp} 
                        onChange={(newFilledFormValues) => this.didUpdateField(filledForm, newFilledFormValues)} 
                        showValidationErrors={this.state.showValidationErrors}
                        viewProvider={this.props.viewProvider}
                        validator={Validator}
                    /> 
                );

                return (
                    <ReactFormChildrenView
                        key={"cartformcontent_" + this.getFilledFormUniqID(filledForm)}
                        formName={formDef.name}
                        formDescription={formDef.description}
                        buttons={filledAutoBtns}
                    >
                        {formContent}
                    </ReactFormChildrenView>
                );
            });
        }

        return cartFormCtls;
    }

    createOrderFormCtls() {
        const ReactFormChildrenView = this.props.viewProvider.getFormChildrenView();
        let orderFormCtls = null;
        
        if(this.props.saleQuestionnaireKit.EventForms 
            && this.props.saleQuestionnaireKit.EventForms.orderForms 
            && this.props.saleQuestionnaireKit.EventForms.orderForms.length > 0) {

            orderFormCtls = map(this.props.saleQuestionnaireKit.EventForms.orderForms, (formDef) => {
                const filledForm = this.getFilledForm(formDef, 0);
                let filledAutoBtns = null;

                if (formDef.hasAutoFillInfo) {
                    filledAutoBtns = this.createButtons(filledForm, formDef);
                }

                const formContent = (
                    <ReactForm
                        key={"orderform_" + this.getFilledFormUniqID(filledForm)}
                        form={formDef} 
                        filledForm={filledForm.Values} 
                        validationErrors={this.getValidationErrors(formDef, filledForm)}
                        infoSupp={filledForm.InfoSupp} 
                        onChange={(newFilledFormValues) => this.didUpdateField(filledForm, newFilledFormValues)} 
                        showValidationErrors={this.state.showValidationErrors}
                        viewProvider={this.props.viewProvider}
                        validator={Validator}
                    /> 
                );

                return (
                    <ReactFormChildrenView
                        key={"orderformcontent_" + this.getFilledFormUniqID(filledForm)}
                        formName={formDef.name}
                        formDescription={formDef.description}
                        buttons={filledAutoBtns}
                    >
                        {formContent}
                    </ReactFormChildrenView>
                );
            });
        }

        return orderFormCtls;
    }

    getFilledForms(formDef) {
        return map(this.props.saleQuestionnaireKit.TicketInfos, (ticket, _ticketIndex) => {
            return this.getFilledForm(formDef, ticket.id);
        });
    }

    createTicketFormsCtls() {
        const ReactFormChildrenView = this.props.viewProvider.getFormChildrenView();
        let ticketFormsCtls = null;
        
        if(this.props.saleQuestionnaireKit.EventForms 
            && this.props.saleQuestionnaireKit.EventForms.ticketForms 
            && this.props.saleQuestionnaireKit.EventForms.ticketForms.length > 0) {

            ticketFormsCtls = flatMap(this.props.saleQuestionnaireKit.EventForms.ticketForms, (formDef) => {
                const sortedFilledForms = this.sortFilledForms(formDef, this.getFilledForms(formDef));
                return map(sortedFilledForms, (filledForm, index) => {
                    //const filledForm = this.getFilledForm(formDef, ticket.id);
                    let filledAutoBtns = null;
                    const ticketDescription = <span className="text-primary">{filledForm.Values.priceName} #{index + 1}</span>;

                    if (formDef.hasAutoFillInfo) {
                        filledAutoBtns = this.createButtons(filledForm,formDef);
                    }

                    const formContent = (
                        <ReactForm
                            key={"ticketform_" + this.getFilledFormUniqID(filledForm)}
                            form={formDef} 
                            filledForm={filledForm.Values}
                            validationErrors={this.getValidationErrors(formDef, filledForm)} 
                            infoSupp={filledForm.InfoSupp}
                            onChange={(newFilledFormValues) => this.didUpdateField(filledForm, newFilledFormValues)} 
                            showValidationErrors={this.state.showValidationErrors}
                            viewProvider={this.props.viewProvider}
                            validator={Validator}
                        />
                    );

                    return (
                        <ReactFormChildrenView
                            key={"ticketformcontent_" + this.getFilledFormUniqID(filledForm)}
                            formName={formDef.name}
                            formDescription={formDef.description}
                            ticketDescription={ticketDescription}
                            buttons={filledAutoBtns}>
                            {formContent}
                        </ReactFormChildrenView>
                    );
                });
            });
        }

        return ticketFormsCtls;
    }

    render() {

        const cartFormCtls = this.createCartFormCtls();
        const orderFormCtls = this.createOrderFormCtls();
        const ticketFormsCtls = this.createTicketFormsCtls();

        const errorsMessages = (this.state.showErrorMessage ? <div className="alert alert-danger">Tous les champs requis doivent être remplis pour continuer</div> : null);
        const ReactFormContainerView = this.props.viewProvider.getFormContainerView();

        return (
            <ReactFormContainerView
                cartFormCtls={cartFormCtls}
                orderFormCtls={orderFormCtls}
                ticketFormsCtls={ticketFormsCtls}
                errorsMessages={errorsMessages}
                submitButtonTitle={"Enregistrer"}
                cancelButtonTitle={"Annuler"}
                onSubmit={() => this.handleOnSubmitResults()}
                onCancel={() => this.handleCancel()}
            />
        );
    }

}

SaleQuestionnaireAutoForm.propTypes = {
    saleQuestionnaireKit: PT.shape({
        POSForms: PT.shape({
            cartForms: PT.arrayOf(PT.object)
        }),
        EventForms: PT.shape({
            orderForms: PT.arrayOf(PT.object),
            ticketForms: PT.arrayOf(PT.object)
        }),
        PackageID: PT.number,
        EventID: PT.number,
        EventDateID: PT.number,
        OrderID: PT.number,
        CartID: PT.string,
        OwnerPOSID: PT.number,
        TicketInfos: PT.arrayOf(TicketInfoShape)
    }),
    viewProvider: PT.object,
    isInAdmin: PT.bool,
    afterConfirm: PT.func,
    onCancel: PT.func,
    onContentChange: PT.func
};

SaleQuestionnaireAutoForm.defaultProps = {
    onCancel: null,
    isInAdmin: false
};

